// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { PropsWithChildren } from 'react';
import { GridProps, SpaceProps } from 'styled-system';

import { StyledCell } from './Styled';
import { BaseProps } from '../Base';

export interface CellProps extends BaseProps, SpaceProps, GridProps {
  tag?: string;
  className?: string;
}

export const Cell: React.FC<PropsWithChildren<CellProps>> = ({
  className,
  children,
  ...rest
}) => (
  <StyledCell className={className || ''} {...rest}>
    {children}
  </StyledCell>
);

export default Cell;
